import React from "react";
import ReactDOM from "react-dom/client";
import "twenty-ui/style.css";
import "twenty-ui/theme-light.css";
import "./styles/crm.css";
import App from "./App";
import { CrmUiProvider } from "./twenty-ui";
import { AIWorkbench } from "./features/ai-platform/AIWorkbench";

const developmentAIPath =
  window.location.pathname === "/dev/ai" ||
  window.location.pathname === "/_dev/ai";
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {developmentAIPath ? (
      <AIWorkbench />
    ) : (
      <CrmUiProvider>
        <App />
      </CrmUiProvider>
    )}
  </React.StrictMode>,
);
